// import { Box, Paper, Typography, Grid, Chip } from "@mui/material";
// import React from "react";
// import { useNavigate } from "react-router";
// import { useOutletContext } from "react-router";
// import { useDispatch, useSelector } from "react-redux";
// import { Actions } from "../../redux/Actions/Actions";
// import Loader from "../Loader";
// import { ErrorToast } from "../Toast/message";
// import NotFound from "../../screens/NotFound";

// const ContestCard = () => {
//   const { contest, selectedMatch } = useOutletContext();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const state = useSelector((state) => state);

//   // if (!contest || !selectedMatch) {
//   //   return <Loader spinner={false} visible={true} />;
//   // }

//   if (!contest || !selectedMatch) {
//   return (
//     <Box
//       sx={{
//         backgroundColor: "#E4E4E4",
//         borderRadius: "10px",
//         padding: "20px",
//         border: "2px solid #546779",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         minHeight: "200px",
//       }}
//     >
//        <NotFound />
//     </Box>
//   );
// }

//   const Teams = [
//     {
//       TeamA: "India",
//       TeamB: "England",
//       id: 1,
//     },
//     {
//       TeamA: "India-W",
//       TeamB: "England-W",
//       id: 2,
//     },
//     {
//       TeamA: "India-A",
//       TeamB: "England-A",
//       id: 3,
//     },
//     {
//       TeamA: "India",
//       TeamB: "England",
//       id: 4,
//     },
//   ];

//   const poolValues = [
//     {
//       id:"5",
//       prizePool: 25200,
//       entryFee: 20,
//       maxEntries: 1500,
//       currentEntries: 900,
//     },
//     {
//       id:"6",
//       prizePool: 35200,
//       entryFee: 100,
//       maxEntries: 3500,
//       currentEntries: 900,
//     },
//   ];

//   const handlePoolClick = (data) => {
//     if(data?._id != state?.betslip?.contestId){
//       dispatch({
//       type: Actions.REMOVE_ALL_BETSLIP,
//     });
//     }
//     navigate(`/pools?eventId=${data?.id}`, { state: { poolData: poolValues } });
//     dispatch({
//       type: Actions.MATCH_NAME,
//       data: `${data?.teamH?.name} vs ${data?.teamA?.name}`,
//     });
//      dispatch({
//       type: Actions.CONTEST_ID,
//       data: data._id,
//     });
//     dispatch({
//       type: Actions.EVENT_ID,
//       data: data.id,
//     });
//   };

//   return (
//     <Grid sx={{ width: "100%", marginBottom: "15px" }}>
//       <Paper
//         elevation={3}
//         sx={{
//           border: "1px solid white",
//           borderRadius: "5px",
//           padding: "10px",
//           background: "whitesmoke",
//         }}
//       >
//         <Box
//           sx={{
//             maxHeight: "720px",
//             overflowY: "auto",
//             // Hide scrollbar in WebKit browsers
//             "&::-webkit-scrollbar": {
//               width: "6px",
//             },
//             "&::-webkit-scrollbar-track": {
//               background: "transparent",
//             },
//             "&::-webkit-scrollbar-thumb": {
//               backgroundColor: "transparent",
//             },
//           }}
//         >
//           {contest
//             .filter((item) => item?.displayDate == selectedMatch)
//             .map((item, index) => {
//                return(
//               <Paper
//                 key={index}
//                 elevation={3}
//                 sx={{
//                   p: 2,
//                   borderRadius: 2,
//                   bgcolor: "#fff",
//                   cursor: "pointer",
//                   marginTop: "10px",
//                   marginBottom: "10px",
//                 }}
//                 onClick={() => handlePoolClick(item)}
//               >
//                 <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//                   <Box>
//                      <Box display="flex" justifyContent="initial">
//                        <Box
//                         component="img"
//                         src={item?.teamH?.logo}
//                         sx={{
//                           height: {xs:"60px",md:"80px"},
//                           width: {xs:"60px",md:"80px"},
//                           alignItems:"center"
//                         }}
//                       />
//                     </Box>
//                     <Typography
//                       variant="subtitle1"
//                       sx={{
//                         color: "green",
//                         fontWeight: 600,
//                         textAlign: "start",
//                         marginTop: "5px",
//                         fontSize:{xs:"14px",md:"16px"}
//                       }}
//                     >
//                       {item?.teamH?.name}
//                     </Typography>
//                   </Box>
//                   <Box
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       justifyContent: "space-between",
//                       gap: 1,
//                     }}
//                   >
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         fontWeight: "500",
//                         color: "0D3862",
//                         textAlign:"center",
//                       }}
//                     >
//                       {item?.league?.name}
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{ fontWeight: "600", textAlign: "center" }}
//                     >
//                       V/S
//                     </Typography>
//                     <Typography variant="body2" sx={{ fontWeight: "600" }}>
//                       <Chip
//                         label={item?.displayDate}
//                         size="small"
//                         color="primary"
//                       />
//                     </Typography>
//                   </Box>
//                   <Box>
//                     <Box display="flex" justifyContent="end">
//                       <Box
//                         component="img"
//                         src={item?.teamA?.logo}
//                         sx={{
//                           height: {xs:"60px",md:"80px"},
//                           width: {xs:"60px",md:"80px"},
//                         }}
//                       />
//                     </Box>
//                     <Typography
//                       variant="subtitle1"
//                       sx={{
//                         color: "green",
//                         fontWeight: 600,
//                         textAlign: "end",
//                         marginTop: "5px",
//                         fontSize:{xs:"14px",md:"16px"}
//                       }}
//                     >
//                       {item?.teamA?.name}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Paper>
//               )
//             })}
//         </Box>
//       </Paper>
//     </Grid>
//   );
// };

// export default ContestCard;

import {
  Box,
  Paper,
  Typography,
  Grid,
  Chip,
  Avatar,
  Tooltip,
  ButtonBase,
  Stack,
  Divider,
  useMediaQuery,
  useTheme,
  Skeleton,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router";
import { useOutletContext } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Loader from "../Loader";
import { ErrorToast } from "../Toast/message";
import NotFound from "../../screens/NotFound";
import { FiCalendar, FiClock, FiChevronRight } from "react-icons/fi";

const BRAND = "#082133";
const SOFT_BG = "#f7fafc";

const ContestCard = () => {
  const { contest, selectedMatch, isLoading } = useOutletContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state);

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  const handlePoolClick = (data) => {
    if (data?._id !== state?.betslip?.contestId) {
      dispatch({
        type: Actions.REMOVE_ALL_BETSLIP,
      });
    }
    // navigate(`/pools?eventId=${data?.id}`, { state: { poolData: poolValues } });
    navigate(`/pools?eventId=${data?.id}`);
    dispatch({
      type: Actions.MATCH_NAME,
      data: `${data?.teamH?.name} vs ${data?.teamA?.name}`,
    });
    dispatch({ type: Actions.CONTEST_ID, data: data._id });
    dispatch({ type: Actions.EVENT_ID, data: data.id });
  };

  if (isLoading) {
    return (
      <Grid sx={{ width: "100%", mb: 2 }}>
        <Paper
          elevation={6}
          sx={{
            borderRadius: 3,
            background: `linear-gradient(180deg, #ffffff 0%, ${SOFT_BG} 100%)`,
            border: "1px solid #eef2f7",
            overflow: "hidden",
            p: 2,
          }}
        >
          <Stack spacing={2}>
            {[...Array(4)].map((_, i) => (
              <Box
                key={i}
                sx={{ display: "flex", gap: 2, alignItems: "center" }}
              >
                <Skeleton variant="circular" width={56} height={56} />
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width="60%" height={24} />
                  <Skeleton variant="text" width="40%" height={20} />
                </Box>
                <Skeleton variant="circular" width={56} height={56} />
              </Box>
            ))}
          </Stack>
        </Paper>
      </Grid>
    );
  }

  if (!contest || !selectedMatch) {
    return (
      <Box
        sx={{
          backgroundColor: "#E4E4E4",
          borderRadius: 2,
          p: 3,
          border: "2px solid #546779",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 200,
        }}
      >
        <NotFound />
      </Box>
    );
  }

  return (
    <Grid sx={{ width: "100%", mb: 2 }}>
      <Paper
        elevation={6}
        sx={{
          borderRadius: 3,
          background: `linear-gradient(180deg, #ffffff 0%, ${SOFT_BG} 100%)`,
          border: "1px solid #eef2f7",
          overflow: "hidden",
        }}
      >
        {/* Sticky header row */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            px: { xs: 1.5, sm: 2.5 },
            py: { xs: 1, sm: 1.5 },
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            bgcolor: "rgba(255,255,255,0.9)",
            backdropFilter: "saturate(180%) blur(6px)",
            borderBottom: "1px solid #e6edf4",
          }}
        >
          <Typography
            sx={{
              fontWeight: 800,
              letterSpacing: -0.2,
              color: BRAND,
              fontSize: { xs: "1rem", sm: "1.25rem" },
            }}
          >
            Upcoming Contests
          </Typography>
          <Chip
            icon={<FiCalendar />}
            label={`Date: ${selectedMatch}`}
            aria-label={`Contest date ${selectedMatch}`}
            sx={{
              ml: "auto",
              bgcolor: BRAND,
              color: "#fff",
              borderRadius: 999,
              border: "1px solid rgba(255,255,255,0.28)",
              boxShadow: "0 2px 8px rgba(8,33,51,.25)",
              "& .MuiChip-icon": { color: "#fff", ml: 0.25 },
              "& .MuiChip-label": {
                fontWeight: 800,
                letterSpacing: 0.3,
                px: { xs: 1, sm: 1.25 },
                py: 0.25,
              },
              px: { xs: 0.25, sm: 0.5 },
              height: { xs: 28, sm: 32 },
            }}
          />
        </Box>

        {/* List */}
        <Box
          sx={{
            maxHeight: { xs: "60vh", sm: "72vh" },
            overflowY: "auto",
            "&::-webkit-scrollbar": { width: 6 },
            "&::-webkit-scrollbar-thumb": { backgroundColor: "transparent" },
          }}
        >
          {contest
            .filter((item) => item?.displayDate === selectedMatch)
            .map((item, index) => (
              <ContestRow
                key={`${item?.id || index}`}
                item={item}
                onClick={() => handlePoolClick(item)}
              />
            ))}
        </Box>
      </Paper>
    </Grid>
  );
};

export default ContestCard;

// ======= Subcomponents =======
function ContestRow({ item, onClick }) {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        width: "100%",
        textAlign: "left",
        display: "block",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          mx: { xs: 1, sm: 2 },
          my: { xs: 1, sm: 1.25 },
          p: { xs: 1.25, sm: 2 },
          borderRadius: 2.5,
          border: "1px solid #e7edf3",
          bgcolor: "#fff",
          transition: "all .18s ease",
          position: "relative",
          overflow: "hidden",
          "&:hover": {
            "@media (hover: hover)": {
              transform: "translateY(-2px)",
              boxShadow: "0 8px 24px rgba(8,33,51,.10)",
              borderColor: BRAND,
            },
          },
          "&:active": { transform: "translateY(0) scale(.99)" },
        }}
      >
        <Stack
          direction={{ xs: "row", sm: "row" }}
          alignItems="center"
          spacing={{ xs: 1, sm: 2 }}
          sx={{
            gap: { xs: 1, sm: 2 },
            flexWrap: "nowrap",
            justifyContent: "space-between",
            minWidth: 0,
          }}
        >
          {/* Home team */}
          <TeamCell
            align="left"
            name={item?.teamH?.name}
            logo={item?.teamH?.logo}
          />

          {/* Center info */}
          <CenterCell league={item?.league?.name} startDate={item?.startDate} />

          {/* Away team */}
          <TeamCell
            align="right"
            name={item?.teamA?.name}
            logo={item?.teamA?.logo}
          />
        </Stack>

        <Divider sx={{ my: 1, display: { xs: "block", sm: "none" } }} />
      </Paper>
    </ButtonBase>
  );
}

function TeamCell({ name, logo, align = "left" }) {
  const initials = getInitials(name);
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems="center"
      spacing={{ xs: 0.5, sm: 1.0 }}
      sx={{
        flex: 1,
        minWidth: 0,
        justifyContent: align === "right" ? "flex-end" : "flex-start",
        textAlign: align,
      }}
    >
      <Avatar
        src={logo || undefined}
        alt={name}
        sx={{
          width: { xs: 44, sm: 56 },
          height: { xs: 44, sm: 56 },
          border: "1px solid #e6edf4",
          bgcolor: "#f2f7fb",
          color: BRAND,
          fontWeight: 800,
          fontSize: { xs: 13, sm: 14 },
        }}
      >
        {initials}
      </Avatar>
      <Tooltip title={name} enterDelay={500} disableInteractive>
        <Typography
          component="div"
          sx={{
            fontWeight: 700,
            color: "#05603a",
            textAlign: { xs: "center", sm: align },
            fontSize: { xs: "0.9rem", sm: "1rem" },
            lineHeight: 1.2,
            minWidth: 0,
            // Mobile: allow up to 2 lines, wrap anywhere
            overflow: "hidden",
            whiteSpace: { xs: "normal", sm: "nowrap" },
            textOverflow: { sm: "ellipsis" },
            wordBreak: { xs: "break-word" },
            overflowWrap: { xs: "anywhere" },
            display: { xs: "-webkit-box", sm: "block" },
            WebkitLineClamp: { xs: 2, sm: "unset" },
            WebkitBoxOrient: { xs: "vertical", sm: "unset" },
          }}
        >
          {name}
        </Typography>
      </Tooltip>
    </Stack>
  );
}

function CenterCell({ league, startDate }) {
  return (
    <Stack alignItems="center" sx={{ minWidth: { xs: 72, sm: 200 } }}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 800,
          letterSpacing: 0.4,
          textTransform: "uppercase",
          bgcolor: BRAND,
          color: "#fff",
          px: { xs: 0.75, sm: 1 },
          py: 0.25,
          borderRadius: 1.5,
          fontSize: { xs: "0.68rem", sm: "0.75rem" },
        }}
      >
        {league}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 900,
          letterSpacing: 1,
          mt: 0.5,
          fontSize: { xs: "0.8rem", sm: "0.9rem" },
        }}
      >
        V/S
      </Typography>

      <Typography
        variant="caption"
        sx={{
          fontWeight: 800,
          letterSpacing: 0.4,
          textTransform: "uppercase",
          bgcolor: BRAND,
          color: "#fff",
          px: { xs: 0.75, sm: 1 },
          py: 0.25,
          borderRadius: 1.5,
          fontSize: { xs: "0.68rem", sm: "0.75rem" },
        }}
      >
        <Box
          component="span"
          sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
        >
          <FiClock />
          {new Date(startDate).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </Box>
      </Typography>
    </Stack>
  );
}

function getInitials(name) {
  if (!name) return "?";
  const parts = String(name).split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] || "";
  const last = parts[1]?.[0] || "";
  return (first + last).toUpperCase();
}
